import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CommonColorUtils from "../../../../utils/common_colors";
import CloseIcon from "@mui/icons-material/Close";
import string_utils from "../../../../utils/string_utils";
import stringUtils from "../../../../utils/string_utils";
import Skeleton from "@mui/material/Skeleton";
import {
    styleContainerList,
    styleTableCellHeader
} from "../../../../utils/common_style_for_list";
import CommonTextWithRoundedShape from "../../../../components/CommonTextWithRoundedShape";
import {showErrorToast} from "../../../../components/toast/error_toast";
import {orderDetailsApiCall} from "../../../controllers/order_details_controller";
import {OrderDetailsModel} from "../../../models/order_details_model";
import {
    localDateFormatWithMonthName,
    localTimeFormat
} from "../../../../utils/date_time_convert_utils";
import {
    returnStatusAccordingToStatusCode, returnStatusColorAccordingToStatusCode
} from "./common_color_and_status";
import MyPagination from "../../../../components/pagination/pagination";
import mpsIcon from "../../../../assets/mps_icon.svg"
import {ApiEndPoint} from "../../../../network/api_end_point";
import {fmOrderTrackingUrlFormation} from "../../../../utils/first_mile_tracking_url";

const apiEndPoint = new ApiEndPoint();
const ReturnOrderDetailsScreen = ({open, onClose, navigatedFrom,taskId,driverName}) => {
    const [isBusy, setIsBusy] = useState(false);
    const [orderDetailsList, setOrderDetailsList] = useState([]);
    const [totalCount, setTotalCount] = useState('');
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPages, setTotalPage] = useState(1);
    const [isStart, setIsStart] = useState(false);
    const [totalOrder, setTotalOrder] = useState(0);
    const columns = [
        {id: "orderId", label: stringUtils.orderId},
        {id: "aWB", label: stringUtils.awb},
        {id: "status", label: stringUtils.status.toUpperCase()},
        {id: "assetId", label: stringUtils.assetId},
        {id: "concept", label: stringUtils.concept.toUpperCase()},
        {id: "itemQuantity", label: stringUtils.itemQuantity.toUpperCase()},
        {id: "createdOn", label: stringUtils.orderBookedAt.toUpperCase()},
        {id: "addedToTask", label: stringUtils.addedToTask.toUpperCase()},
    ];

    // style
    const textSmallStyle ={
        padding: '5px 15px 10px 0px',
        fontSize: '12px',
        fontWeight: '400',
    }

    const textSmallBoldStyle ={
        padding: '5px 15px 10px 15px',
        fontSize: '12px',
    }

    const orderDetailsApiCalling =async ()=>{
        try{
            setIsBusy(true);
            const response = await orderDetailsApiCall(taskId,pageSize,page+1);
            if(response) {
                const orderDetailsModel = OrderDetailsModel.fromJson(response);
                setTotalCount(orderDetailsModel.totalCount);
                setOrderDetailsList(orderDetailsModel.orders);
                setTotalPage(orderDetailsModel.totalPages)
                setTotalOrder(orderDetailsModel.count);
            }

        }
        catch (e) {
            showErrorToast('Something went wrong!');
            setOrderDetailsList([]);
            setTotalCount('');
        }
        finally {
            setIsBusy(false);
        }
    }


    useEffect(() => {
        setOrderDetailsList([])
        setTotalCount('');
        if(open) {
            orderDetailsApiCalling()
        }
        // eslint-disable-next-line
    }, [open,page,pageSize]);
    return (
        <>
            <Dialog open={open}  onClose={(event, reason) => {
                if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                    onClose();
                }
            }} maxWidth="lr"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            height: '100vh',
                            overflow: 'hidden',
                        },
                    }}>
                <DialogTitle
                    style={{
                        fontFamily: 'Inter, Arial, sans-serif',
                        fontWeight: '600',
                    }}
                >
                    <div onClick={onClose} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                        <span style={{
                            padding: '10px 15px 10px 15px',
                            color: CommonColorUtils.primaryMainBlue,
                            fontSize: '14px',
                        }}>{navigatedFrom}</span>
                        <span style={{
                            fontSize: '14px',
                            padding: '10px 0px 10px 0px',
                            color: CommonColorUtils.primaryGrey600,
                        }}> > </span>
                        <span style={{
                            padding: '10px 15px 10px 15px',
                            color: CommonColorUtils.primaryGrey600,
                            fontSize: '14px',
                        }}>{string_utils.returnOrders}</span>
                    </div>
                    <span style={{
                        padding: '15px 15px 0px 15px',
                        fontSize: '16px',
                        fontWeight: '550',
                        fontFamily: 'Inter, Arial, sans-serif',
                    }}>{string_utils.taskId} : {taskId}</span>
                    <div onClick={onClose} style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                        <span style={textSmallBoldStyle}>{string_utils.location} : </span>
                        <span style={textSmallStyle}>{orderDetailsList.length>0 ? orderDetailsList[0].location:''}</span>
                        <span style={textSmallBoldStyle}>{string_utils.taskType} : </span>
                        <CommonTextWithRoundedShape
                            text={`${string_utils.return} (${totalCount})`}
                            backgroundColor={
                                CommonColorUtils.kPrimePurpleLightShade
                            }
                            color={
                                CommonColorUtils.kPrimePurpleDarkShade
                            }
                            fontSize={12}
                            verticalPadding={20}
                            horizontalPadding={2}

                        />
                        {driverName!=='' && (
                            <span style={textSmallBoldStyle}>{string_utils.driver} : </span>
                        )}
                        {driverName!=='' && (
                            <span style={textSmallStyle}>{driverName}</span>
                        )}
                    </div>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8, // Adjusted for consistent spacing
                            top: 20,
                            width: '50px',// Adjusted for consistent spacing
                            color: CommonColorUtils.primaryGrey700,
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>


                    <div
                        style={{
                            borderTopLeftRadius: "16px",
                            borderRadius: "16px",
                            border: `1px solid ${CommonColorUtils.primaryGrey300}`,
                            height: "90%",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {isBusy?(<>
                            {Array.from({ length: 20 }).map((_, index) => (
                                <div>
                                    <Skeleton
                                        key={index}
                                        variant="rectangular"
                                        width={'100%'}
                                        height={80}
                                        style={{ marginBottom: '8px' ,flex: 1,
                                            overflowX: 'auto',}} // Optional styling for spacing
                                    />
                                </div>
                            ))}
                        </>):(
                            <TableContainer style={styleContainerList}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.id||column.label}
                                                    align={"left"}
                                                    style={styleTableCellHeader}
                                                >
                                                    {column.label}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {orderDetailsList.map((row, rowIndex) => (
                                            <TableRow
                                                key={rowIndex}
                                                style={{
                                                    backgroundColor: CommonColorUtils.kPrimaryPureWhite,
                                                }}
                                            >
                                                {columns.map((column, columnIndex) => (
                                                    <TableCell
                                                        key={`${rowIndex}-${columnIndex}`}
                                                        align={"left"}
                                                        style={{
                                                            padding: "0px",
                                                            paddingLeft: column.id === "orderId" && row['isMps'] ?'0px':"10px",
                                                            paddingRight: "20px",
                                                            height: "54px",
                                                            borderBottom: `1px solid ${CommonColorUtils.primaryGrey300}`,
                                                            width: `${100 / columns.length}%`,
                                                            fontFamily: "Inter, Arial, sans-serif",
                                                            color: CommonColorUtils.primaryGrey700,
                                                            fontWeight: column.id === "orderId" ? 600 : 400,
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {(() => {
                                                            if(column.id === "orderId") {
                                                                return (
                                                                    <>
                                                                        <div onClick={()=>window.open(fmOrderTrackingUrlFormation(row['aWB']))}
                                                                             style={{display: 'flex', alignItems: 'center',cursor:'pointer'}} >
                                                                            { row['isMps']&& (<img src={mpsIcon}/>)}
                                                                            <span>{row[column.id]}</span>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                            if (column.id === "shipmentDetails") {
                                                                return row[column.id].map((item) => (
                                                                    <div>{item.awbNumber}</div>
                                                                ));
                                                            }
                                                            if(column.id==='status'){
                                                                return  <span style={{color:returnStatusColorAccordingToStatusCode(row[column.id])}}>{returnStatusAccordingToStatusCode(row[column.id])}</span>
                                                            }
                                                            if (column.id === 'createdOn' || column.id === 'addedToTask') {
                                                                return `${localDateFormatWithMonthName(row[column.id])} at ${localTimeFormat(row[column.id])}`;
                                                            } else {
                                                                return row[column.id]||'-';
                                                            }
                                                        })()}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </div>

                    {orderDetailsList.length>0&&( <div style={{marginTop:'25px'}}>
                        <MyPagination
                            currentPage={page + 1}
                            totalPages={totalPages}
                            onPageChange={setPage}
                            rowsPerPage={pageSize}
                            onRowsPerPageChange={setPageSize}
                            totalEntries={totalOrder}
                            setIsStart={setIsStart}
                            marginRight="35px"
                        /></div>)}

                </DialogContent>
            </Dialog>
        </>
    );

}

export default ReturnOrderDetailsScreen;